import "./AppointmentsScreen.scss";
import AppointmentsListComponent from "../appointments-list/AppointmentsListComponent";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../shared/services";
import momentTimezone from "moment-timezone";
import ButtonComponent from "../../shared/components/button/ButtonComponent";
import AlertCardComponent from "../../shared/components/alert-card/AlertCardComponent";
import LinkComponent from "../../shared/components/link/LinkComponent";
import ModalComponent from "../../shared/components/modal/ModalComponent";
import FacilityDetailsComponent from "../client-cases/facility-details/FacilityDetailsComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";


interface AppointmentsScreenProps {

}

const AppointmentsScreen = (props: AppointmentsScreenProps) => {
    const [upcomingAppointment, setUpcomingAppointment] = useState<any>({});
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const handleBookAppointment = useCallback(() => {
        if (currentUser?.independent_appointment_booking === 'Restricted') {
            setIsContactUsModalOpen(true)
        } else {
            // navigate(CommonService._routeConfig.BookAppointmentRoute())
            const appointmentUrl = CommonService._routeConfig.BookAppointmentRoute();
            window.open(appointmentUrl, '_blank');
        }
    }, [currentUser]);

    const getUpcomingAppointmentDetails = useCallback(() => {
        CommonService._appointment.GetUpComingAppointmentDetails({timezone: momentTimezone.tz.guess()})
            .then((response: any) => {
                setUpcomingAppointment(response.data);
            })
            .catch((error: any) => {
                setUpcomingAppointment({});
            })

    }, []);

    useEffect(() => {
        getUpcomingAppointmentDetails();
    }, [getUpcomingAppointmentDetails]);


    return (
        <div className="appointments-screen list-screen">
            <div className="list-screen__header">
                <div className="list-screen__header-title">
                    My Appointments
                </div>

                <div className="list-screen__header-actions">
                    {Object.keys(upcomingAppointment)?.length > 0 &&
                        <AlertCardComponent className={'warning mrg-right-15'}
                                            message={'You have an upcoming appointment scheduled.'}
                                            action={<LinkComponent
                                                route={CommonService._routeConfig.AppointmentDetails(upcomingAppointment?._id)}
                                                className={'pdd-left-10'}>
                                                View Details
                                            </LinkComponent>}/>}
                    <ButtonComponent onClick={handleBookAppointment}>
                        Book Appointment
                    </ButtonComponent>
                </div>
            </div>
            <div className="list-screen__body">
                <AppointmentsListComponent upcomingAppointment={upcomingAppointment}/>
            </div>

            <ModalComponent isOpen={isContactUsModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-30 mrg-top-10'}
                                                          onClick={() => setIsContactUsModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsContactUsModalOpen(false)}>
                <FacilityDetailsComponent
                    title={<>Online Booking Unavailable.<br/> Contact us to book an appointment.</>}/>
            </ModalComponent>
        </div>
    );

};

export default AppointmentsScreen;
